import { useState } from "react";
import { useApi, useResource } from "@/lib/api";
import { PageHeader, Panel, StatusPill, Loading, ErrorNote, fmtTime } from "@/components/kit";
import { TaskList } from "@/pages/Tasks";

export default function QA() {
  const call = useApi();
  const tasks = useResource("/tasks");
  const [check, setCheck] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => { setBusy(true); try { setCheck(await call("/qa/self-check")); } catch (e) { setCheck({ error: e }); } setBusy(false); };
  return (
    <div>
      <PageHeader eyebrow="Independent QA · Evidence" title="Independent QA">
        <button data-testid="qa-run-self-check" onClick={run} disabled={busy} className="rounded-sm bg-[var(--cc-navy)] px-5 py-2 text-sm text-white transition-colors hover:bg-[var(--cc-signal)] hover:text-[var(--cc-navy)] disabled:opacity-50">{busy ? "Running…" : "Run governance self-check"}</button>
      </PageHeader>
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Live governance self-check" testId="qa-self-check">
          {!check ? <p className="text-sm text-[var(--cc-muted)]">Run the server-side check to produce fresh, audited evidence.</p>
            : check.error ? <ErrorNote error={check.error} />
            : <ul className="space-y-2">{check.checks.map((c) => (
              <li key={c.check} className="flex items-center justify-between gap-3 text-sm"><span>{c.check}</span><StatusPill status={c.passed ? "passed" : "failed"} /></li>))}</ul>}
        </Panel>
        <Panel title="Independent QA runs" testId="qa-runs">
          {!check?.qa_runs?.length ? <p className="text-sm text-[var(--cc-muted)]">Run the self-check to load recorded independent QA runs.</p>
            : check.qa_runs.map((r) => (
              <div key={r.id} className="mb-4 border-l-2 border-[var(--cc-signal)] pl-3" data-testid={`qa-run-${r.id}`}>
                <div className="flex items-center justify-between gap-2"><p className="font-medium text-[var(--cc-navy)]">{r.title}</p><StatusPill status={r.status} /></div>
                <p className="text-xs text-[var(--cc-muted)]">{r.tester} · {fmtTime(r.created_at)} · {r.passed}/{r.total} passed</p>
                <ul className="mt-2 space-y-0.5 text-xs">{(r.highlights || []).map((h, i) => <li key={i}>▸ {h}</li>)}</ul>
              </div>))}
        </Panel>
      </div>
      <Panel title="QA tasks" className="mt-6">{tasks.loading ? <Loading /> : tasks.error ? <ErrorNote error={tasks.error} /> : <TaskList tasks={tasks.data.filter((t) => t.category === "qa")} />}</Panel>
    </div>
  );
}
